import { rei } from "@/services/api"

class HospitaisService {
  static getHospitais (params = null) {
    if (params == null) {
      return rei.get(`hospitais`).then(res => res.data)
    } else {
      let query = []
      query.push(params.perPage ? 'perPage=' + params.perPage : '')
      query.push(params.page ? 'page=' + params.page : '')
      query.push(params.nome ? 'nome=' + params.nome : '')
      query.push(params.uf ? 'uf=' + params.uf : '')
      query.push(params.cidade ? 'cidade=' + params.cidade : '')
      query.push(params.ativo ? 'ativo=' + params.ativo : '')
      query.push(params.cartorio_id ? 'cartorio_id=' + params.cartorio_id : '')
      return rei.get(`hospitais?${query.join('&')}`).then(res => res.data)
    }
  }

  static saveHospitais (hospital) {
    return rei.post(`hospitais`, hospital).then(res => res.data)
  }

  static updateHospitais (hospital, id) {
    return rei.put(`hospitais/${id}`, hospital).then(res => res.data)
  }

  static excludeHospital (id) {
    return rei.post(`hospitais/${id}`)
  }
}

export default HospitaisService
